import { render } from "./CallCompTab.vue?vue&type=template&id=6e424a70"
import script from "./CallCompTab.vue?vue&type=script&lang=js"
export * from "./CallCompTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__